var $ = jQuery = require('jquery');
angular.module('blc').directive('redControl', directive);
directive.$inject = ['quote','redcontrol'];
function directive(quote, redcontrol) {
  return {
    restrict:    'A',
    replace:     true,
    templateUrl: '/red-control.html',
    link: link,
    controller: ['$scope', '$element', function($scope, $element) {
      $scope.redcontrol = redcontrol
    }],
  }
  function link($scope, $element) {
    $element.on('click', 'li', function(evt) {
      redcontrol.popup = this.getAttribute('data-popup')
    })
    $('body').on('click keyup', function(evt) {
      if (evt.keyCode===27) redcontrol.popup=null
      if ($(evt.target).closest('.animNav').length>0) return;
      redcontrol.popup=null
    })
  }
}



/*****************
 ** WEBPACK FOOTER
 ** ./gulp/assets/javascripts/redcontrol-directive.js
 ** module id = 21
 ** module chunks = 0
 **/